import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltCommentsSidebarV2FilterDropdownContentList from './VeltCommentsSidebarV2FilterDropdownContentList/VeltCommentsSidebarV2FilterDropdownContentList';
var VeltCommentsSidebarV2FilterDropdownContent = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-dropdown-content-v2-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2FilterDropdownContent.List = VeltCommentsSidebarV2FilterDropdownContentList;
export default VeltCommentsSidebarV2FilterDropdownContent;
